// Central business facts for the RollOver site, sourced from the current
// website (footer, Google Maps embed, WhatsApp widget, delivery listings).

export const business = {
  name: "RollOver",
  legalName: "RollOver Warangal",
  slogan: "Good Food. Good Mood. Great Times.",
  ringText: "Good food. • Good mood. • Great times. •",
  // Address as used by the current site footer and the Google Maps embed.
  address: {
    lines: ["Chaitanyapuri Colony", "Hanamkonda, Telangana 506004"],
    landmark: "Opposite Tara Gardens, Prashanthnagar Colony",
  },
  // Phone as used by the current site footer and WhatsApp widget.
  phone: {
    display: "+91 86880 66805",
    whatsapp: "+91 86880 66805",
  },
  // Hours as listed in the current site footer.
  hours: [
    { days: "Monday – Friday", time: "11am – 11pm" },
    { days: "Saturday & Sunday", time: "10am – 11pm" },
  ],
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3794.753870135992!2d79.53094107472351!3d17.990184585161202!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a334fc0d9dd43e9%3A0x64a26472586d2ea2!2sRollOver%20Warangal!5e0!3m2!1sen!2sin!4v1694512394133!5m2!1sen!2sin",
  directionsUrl:
    "https://www.google.com/maps/search/?api=1&query=RollOver%20Warangal%20Chaitanyapuri%20Colony%20Hanamkonda",
  providers: [
    {
      id: "swiggy",
      name: "Swiggy",
      url: "https://www.swiggy.com/restaurants/roll-over-opp-tara-gardens-prashanthnagar-colony-warangal-75960?sld=false",
      note: "Current menu, service area and payment are handled on Swiggy.",
    },
    {
      id: "zomato",
      name: "Zomato",
      url: "https://www.zomato.com/warangal/roll-over-hanamakonda/order",
      note: "Live menu, delivery area and payment are handled on Zomato.",
    },
  ],
  // Social profiles as linked from the current site.
  social: [
    { id: "instagram", label: "Instagram", url: "https://instagram.com/rolloverwarangal?igshid=YmMyMTA2M2Y=" },
    { id: "facebook", label: "Facebook", url: "https://www.facebook.com/Rollovernitw/" },
    { id: "youtube", label: "YouTube", url: "https://youtube.com/channel/UChySNfbzG3o5qI6tdlSasZA" },
    { id: "twitter", label: "Twitter", url: "https://twitter.com/BeyondB98599580" },
  ],
  hashtag: "#GoodFoodGoodMood",
};

export const navLinks = [
  { to: "/what-is-rollover", label: "What is RollOver?" },
  { to: "/our-story", label: "Our Story" },
  { to: "/menu", label: "Our Menu" },
  { to: "/faqs", label: "FAQs" },
  { to: "/find-us", label: "Find Us" },
  { to: "/pairings", label: "Pairings" },
];

export const footerLinks = [
  ...navLinks.filter((l) => l.to !== "/find-us"),
  { to: "/terms", label: "Terms" },
  { to: "/privacy", label: "Privacy Policy" },
];

// Existing application routes that remain live (events, bookings, full menu).
export const legacyLinks = [
  { to: "/menu/c/ice-cream-rolls", label: "Full menu" },
  { to: "/events", label: "Celebrations" },
  { to: "/book-event", label: "Book an event" },
  { to: "/offers", label: "Offers" },
  { to: "/ingredients", label: "Ingredients" },
  { to: "/club", label: "Club" },
  { to: "/ambassador", label: "Ambassador" },
  { to: "/feedback", label: "Feedback" },
];
